import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { portalApi } from '../api';
import { usePortalAuth } from '../context/PortalAuthContext';
import { toast } from 'sonner';

const normalizeToken = (input) => {
  if (!input) return '';
  try {
    const url = new URL(input);
    return url.searchParams.get('token') || input;
  } catch (error) {
    return input;
  }
};

export default function PortalLogin() {
  const navigate = useNavigate();
  const { storeSession } = usePortalAuth();
  const [form, setForm] = useState({ email: '', token: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    try {
      const response = await portalApi.exchangeInvite({
        email: form.email.trim(),
        token: normalizeToken(form.token.trim()),
      });
      storeSession(response);
      toast.success('Signed in to the client portal');
      navigate('/portal/invoices');
    } catch (error) {
      const detail = error?.response?.data?.detail || 'Unable to activate invite';
      toast.error(detail);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md bg-white shadow-md rounded-xl p-8 space-y-6">
        <div className="text-center space-y-2">
          <p className="text-sm uppercase tracking-wide text-slate-500">UTIS Accounting</p>
          <h1 className="text-2xl font-semibold text-slate-900">Client portal</h1>
          <p className="text-sm text-slate-500">Paste the invite link you received via email to get started.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-600" htmlFor="portal-email">
              Work email
            </label>
            <input
              id="portal-email"
              name="email"
              type="email"
              required
              value={form.email}
              onChange={handleChange}
              className="mt-1 w-full rounded border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-600" htmlFor="portal-token">
              Invite link or token
            </label>
            <textarea
              id="portal-token"
              name="token"
              required
              rows={3}
              value={form.token}
              onChange={handleChange}
              className="mt-1 w-full rounded border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-md bg-indigo-600 py-2 text-white font-medium hover:bg-indigo-500 disabled:opacity-60"
          >
            {submitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
